module.exports = __webpack_public_path__ + "static/media/westbury-living.8ac3d1ed.jpg";